let e = process.env.NODE_ENV;
let nodeEnv = e && !!e ? process.env.NODE_ENV : "local";

import config from "./envConfig";
import _ from "lodash";

let state = _.cloneDeep(config[nodeEnv]);

state.env = nodeEnv;
console.log("state", state);

export const env = {
  namespaced: true,

  state: state,
  getters: {},
  mutations: {},
  actions: {}
};
